import Text from 'components/Text/Text';
import React, { useContext, useState, useMemo } from 'react';
import { IFirmwareContext, FirmwareContext } from '../../../../../firmwareState/firmwareContext';
import { IItemFirmware } from 'types';
import { firmwareTypes } from 'appConstants';
import DataController from 'components/DataController/DataController';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemFirmware;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForDeletion, changeTypeOfModalWindow } = useContext<IFirmwareContext>(FirmwareContext);
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);

	const getActualTypeName = () =>
		firmwareTypes.find((el) => el.firmwareTypeID === data.type)?.firmwareTypeName || null;
	const actualTypeName = useMemo(() => getActualTypeName(), [data]);
	const isUnAssigned = !data.restaurants.length;

	const containerClasses = classNames(style.container, {
		[style.openInfo]: isOpenInfo,
		[style.itemUnAssigned]: isUnAssigned,
	});
	const nameRowClasses = classNames(style.name, style.row);
	const versionRowClasses = classNames(style.version, style.row);
	const descriptionRowClasses = classNames(style.description, style.row);
	const firmwareTypeRowClasses = classNames(style.firmwareType, style.row);
	const actionRowClasses = classNames(style.action, style.row);

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
		changeTypeOfModalWindow('toConfirmDeleteItem');
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<Text className={nameRowClasses} translationKey={data.name} withTooltip={true} />
				<Text className={versionRowClasses} translationKey={data.version} withTooltip={true} />
				<Text className={descriptionRowClasses} translationKey={data.description} withTooltip={true} />
				<Text className={firmwareTypeRowClasses} translationKey={actualTypeName} withTooltip={true} />
				<div className={actionRowClasses}>
					<DataController
						onClickDelete={handleSetIdForDeletion}
						URLWithIDToEdit={`/app/firmware/edit?firmwareID=${data.id}`}
						size="smallBtn"
					/>
				</div>
			</div>
		</div>
	);
};

export default Item;
